import { type FieldContentsData } from 'javascripts/shared-types';
import Field from '../../Field';
import { round } from 'lodash';
import moment from 'moment';

export class TimeInStatus extends Field {
  static attributesForModel() {
    return ['timeInCurrentStatus'];
  }

  get title() {
    return 'Time in status';
  }

  exampleContents(): FieldContentsData {
    return {
      pill: {
        text: `3d`,
        color: '#e1e1e1',
        icon: { name: 'fa-regular fa-stopwatch' },
      },
    };
  }

  contentsForRecord(record): FieldContentsData {
    const inDays = round(
      moment.duration(record.timeInCurrentStatus || 0, 'seconds').asDays(),
      0
    );

    return {
      pill: {
        text: `${inDays}d`,
        color: '#e1e1e1',
        icon: { name: 'fa-regular fa-stopwatch' },
      },
    };
  }
}
